import { render, staticRenderFns } from "./editPersonModal.vue?vue&type=template&id=a42b67f2"
import script from "./editPersonModal.vue?vue&type=script&lang=js"
export * from "./editPersonModal.vue?vue&type=script&lang=js"
import style0 from "./editPersonModal.vue?vue&type=style&index=0&id=a42b67f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports